import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { LoadingSpinner as FoundationsLoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
export const LoadingSpinner = () => /*#__PURE__*/_jsx(TFlex, {
  align: "center",
  justify: "center",
  children: /*#__PURE__*/_jsx(FoundationsLoadingSpinner, {})
});